module.exports = function () {
  this.app.$on('refreshCredits', event => {
    this.sdk.get('/1.1/me/credits', {
      token: event || this.session.token
    }, res => {
      if (!res.error) {
        if (event) this.session.useToken(event)
        this.app.credits = res.credits
      }
      if (event && event.callback) {
        event.callback(res)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/events/refresh-credits.js